var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg18(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4295_60084",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.000976562 1.90735e-06H32.001V32H0.000976562V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4295_60084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.807 6.88931C18.6357 6.39956 17.3501 6.12863 16.0011 6.12863C10.5482 6.12863 6.12793 10.549 6.12793 16.0018C6.12793 21.4546 10.5482 25.875 16.0011 25.875C21.4539 25.875 25.8742 21.4546 25.8742 16.0018C25.8742 14.6528 25.6034 13.3672 25.1136 12.1959",
    stroke: "#00C05B",
    strokeWidth: 1.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2841 13.9468C20.2841 15.0807 19.3649 16 18.2309 16C17.097 16 16.1777 15.0807 16.1777 13.9468C16.1777 12.8129 17.097 11.8936 18.2309 11.8936C19.3649 11.8936 20.2841 12.8129 20.2841 13.9468Z",
    stroke: "#00C05B",
    strokeWidth: 1.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2841 18.0405C20.2841 19.1745 19.3649 20.0938 18.2309 20.0938C17.097 20.0938 16.1777 19.1745 16.1777 18.0405C16.1777 16.9066 17.097 15.9873 18.2309 15.9873C19.3649 15.9873 20.2841 16.9066 20.2841 18.0405Z",
    stroke: "#00C05B",
    strokeWidth: 1.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6016 14.2956L13.0033 11.8939V20.0938",
    stroke: "#00C05B",
    strokeWidth: 1.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9385 10.9219V7.18431",
    stroke: "#00C05B",
    strokeWidth: 1.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0693 9.0625H24.8069",
    stroke: "#00C05B",
    strokeWidth: 1.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg18);
export default __webpack_public_path__ + "static/media/18+.e5b15b01d88cfa995bf1c51686ca57e8.svg";
export { ForwardRef as ReactComponent };